import { StyledGridColumnProps } from '@components/Grid/Grid.model';
import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const BannerSpacing = styled.div`
  margin-top: 128px;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    margin-top: 96px;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    margin-top: 64px;
  }
`;

export const BannerLayout = styled.div`
  height: fit-content;
  max-height: 1200px;

  width: 100%;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    max-height: 996px;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
  }
`;

export const BannerSection = styled.div`
  width: 100%;
  max-height: 1200px;

  overflow-x: hidden;
  overflow-y: hidden;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: #071630;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    max-height: 996px;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
  }
`;

export const BannerProductCardViewport = styled.div`
  width: 100%;
  position: relative;
`;

export const BannerProductCardTrack = styled.div<{ $offset: number }>`
  display: flex;
  gap: 32px;
  cursor: grab;

  will-change: transform;
  backface-visibility: hidden;
`;

export const BannerProductCard = styled.div<{ bgImg: any; $offset: any }>`
  flex: 0 0 auto;

  width: 1232px;
  aspect-ratio: 1232 / 480;
  border-radius: 32px;
  background: #000;

  transform: translateX(${({ $offset }) => `${$offset}px`});
  transition: transform 0.4s ease-out;
  ${({ bgImg }) =>
    bgImg &&
    `
    background-image: url(${bgImg});
    background-size: cover;
    background-repeat: no-repeat; 
    background-position: center;
  `}

  box-shadow : 0px 0px 24px rgba(0, 0, 0, 0.48); /* ✅ 그림자 추가 */

  padding: 64px;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    width: calc(100% - 48px);
    height: 400px;
    padding: 32px;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    width: calc(100% - 32px);
    height: 360px;
    padding: 24px;
  }
`;

/** Banner.style.ts */
export const BannerProductCardLayout = styled.div`
  display: flex;
  gap: 32px;

  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: var(--center-pad); /* JS로 주입 */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const BannerProductButton = styled.div`
  padding: 8px;
  border: 1px solid #fff;

  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const BanenrShowMore = styled.a`
  display: flex;
  flex-direction: row;

  margin-top: 32px;
  align-items: center;
  height: auto;
  cursor: pointer;
  max-width: 100%;
`;

/* 도트 인디케이터 ----------------------------------------------------- */
export const DotContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: start;
  gap: 8px;
`;

export const Dot = styled.span<{ $active: boolean }>`
  width: 32px;
  height: 8px;
  border-radius: 4px;
  background: ${({ $active }) => ($active ? '#ffffff' : 'rgba(255, 255, 255, 0.25)')};
  transition: background 0.3s;
`;

export const BannerBtn = styled.button`
  display: flex;aa
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: var(--primitive-blue-600, #2A70F0);
  cursor : pointer;
  border : none;
`;

export const BannerBtnAtag = styled.a`
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: var(--primitive-blue-600, #2a70f0);
  cursor: pointer;
`;

const moveFromRightToLeft = keyframes`
  from {
    background-position: 95% 5%; 
  }
  to {
    background-position: 15% 5%;
  }
`;

const fadePulse = keyframes`
  0% { opacity: 1; }
  33% { opacity: 0.6; }
  70% { opacity: 1; }
  100% { opacity: 1; }
`;

export const BannerImageSection = styled.div<{ img: string }>`
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: 70px;
    right: 80px;

    width: 620px;
    height: 620px;
    background-image: url(${(props) => props.img});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    animation: ${fadePulse} 3s ease-in-out infinite;
    pointer-events: none; /* 클릭 방지 */



    @media (max-width : 1440px){
      
    top: 70px;
    right: 20px;
  }
    
  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    
    width: 340px;
    height: 340px;

    top: 70px;
    right: 50px;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    
    width: 250px;
    height: 250px;

    top: 110px;

  }
`;

export const BannerVideoSection = styled.div<{ scrollPosition: number }>`
  width: fit-content;
  display: flex;
  max-height: 480px;
  margin-top: auto;
  z-index: 4;

  display: flex;
  object-fit: contain;

  transform: translateY(1px);

  aspect-ratio: 3840 / 1080;

  ${({ scrollPosition }) =>
    scrollPosition && `transform: translateY(-${scrollPosition / 1.2}px) scale(${100 - scrollPosition / 20}%); opacity : ${1 - scrollPosition / 500};`}

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    max-height: 400px;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    max-height: 300px;
    transform: none;
    opacity: 1;
  }
`;

export const VideoBox = styled.div`
  position: relative;
  width: fit-content;
  display: flex;
  justify-content: center;
  overflow: hidden;

  border: 1px solid var(--border-translucent-light, rgba(0, 0, 0, 0.08));

  clip-path: polygon(14% 0, 86% 0, 100% 100%, 0% 100%);
  border-top-left-radius: 16px; /* 상단 좌측 코너에 둥근 모서리 추가 */
  border-top-right-radius: 16px; /* 상단 우측 코너에 둥근 모서리 추가 */

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8)); /* 그라데이션 추가 */
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    z-index: 4;
    transform: translateY(50%);
  }

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
  }
`;

export const ImageInner = styled.div<StyledGridColumnProps>`
  display : flex; 
  z-index : 3;

  width : 100%;
  margin-bottom : 36px;

  justify-content: start;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    
`;
